<div
  class="custom-date-picker"
  [class.mode-date]="effectiveMode === 'date'"
  [class.mode-datetime]="effectiveMode === 'datetime'"
  [class.mode-time]="effectiveMode === 'time'"
>
  <div
    #pickerInput
    class="date-picker-input"
    (click)="togglePicker($event)"
    [class.disabled]="disabled"
  >
    <div class="input-content" [class.has-clear]="showClearButton">
      <span class="display-value" [attr.data-placeholder]="placeholder">{{
        getDisplayValue()
      }}</span>
      <button
        type="button"
        class="clear-button"
        *ngIf="showClearButton"
        (click)="onClearClick($event)"
        aria-label="Clear selection"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <span
        class="input-icon"
        *ngIf="effectiveMode !== 'time' || !showClearButton"
        aria-hidden="true"
      >
        <svg
          *ngIf="effectiveMode !== 'time'"
          class="calendar-icon"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.90039 7.42715C1.90039 4.78728 1.90039 3.46735 2.72049 2.64725C3.54059 1.82715 4.86053 1.82715 7.50039 1.82715C10.1403 1.82715 11.4602 1.82715 12.2803 2.64725C13.1004 3.46735 13.1004 4.78728 13.1004 7.42715C13.1004 10.067 13.1004 11.3869 12.2803 12.207C11.4602 13.0271 10.1403 13.0271 7.50039 13.0271C4.86053 13.0271 3.54059 13.0271 2.72049 12.207C1.90039 11.3869 1.90039 10.067 1.90039 7.42715Z"
            stroke="#555963"
            stroke-width="1.5"
          />
          <path
            d="M9.83301 0.817871V3.1512"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.16699 0.817871V3.1512"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.25 5.1333H12.75"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          *ngIf="effectiveMode === 'time'"
          class="chevron-icon"
          [class.chevron-icon--open]="isOpen"
          width="14"
          height="14"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.28 7.38L10 12.1L14.72 7.38"
            stroke="#15172E"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </div>

  <div
    #pickerDropdown
    class="date-picker-dropdown"
    [class.mode-date]="effectiveMode === 'date'"
    [class.mode-datetime]="effectiveMode === 'datetime'"
    [class.mode-time]="effectiveMode === 'time'"
    [class.align-right]="dropdownAlign === 'right'"
    [class.fixed-overlay]="fixedOverlay"
    [class.is-positioned]="fixedOverlayReady"
    [class.is-open]="isOpen"
    [attr.hidden]="isOpen ? null : true"
    (click)="$event.stopPropagation()"
    [@slideInOut]
    [@.disabled]="fixedOverlay || !isOpen"
  >
    <div class="dropdown-content">
      <div class="calendar-section" *ngIf="showsCalendar">
        <div class="calendar-header">
          <div class="calendar-nav">
            <button
              type="button"
              class="nav-btn"
              (click)="previousMonth()"
              aria-label="Previous month"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 15L7.5 10L12.5 5"
                  stroke="#15172E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <span class="current-month">{{ getCurrentMonthYear() }}</span>
            <button type="button" class="nav-btn" (click)="nextMonth()" aria-label="Next month">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 15L12.5 10L7.5 5"
                  stroke="#15172E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="calendar-body">
          <div class="calendar-days">
            <div class="day-header" *ngFor="let day of weekDays; trackBy: trackByIndex">
              {{ day }}
            </div>
          </div>

          <div class="calendar-grid">
            <div
              class="calendar-day"
              *ngFor="let day of calendarDays; trackBy: trackByIndex"
              [class.other-month]="!day.isCurrentMonth"
              [class.selected]="isSelectedDate(day.date)"
              [class.today]="isToday(day.date)"
              [class.past-date]="isDateDisabled(day.date)"
              (click)="onDateSelect(day.date)"
              [class.disabled]="!day.isCurrentMonth || isDateDisabled(day.date)"
            >
              {{ day.dayNumber }}
            </div>
          </div>
        </div>
      </div>

      <div class="time-picker-section" *ngIf="showsTimePicker">
        <div class="time-picker-header" *ngIf="effectiveMode !== 'time'">
          <h3>Choose time</h3>
        </div>
        <div class="time-slots-container">
          <div class="time-slots-scroll">
            <button
              type="button"
              class="time-slot"
              *ngFor="let slot of getVisibleTimeSlots(); trackBy: trackByIndex"
              [class.selected]="isTimeSlotSelected(slot)"
              [class.available]="
                isTimeSlotAvailableForDate(slot, selectedDate || getCurrentDate()) &&
                !isTimeSlotDisabled(slot)
              "
              [class.unavailable]="
                !isTimeSlotAvailableForDate(slot, selectedDate || getCurrentDate())
              "
              [class.past-time]="isTimeSlotDisabled(slot) && !isTimeSlotSelected(slot)"
              [disabled]="isTimeSlotDisabled(slot)"
              (click)="onTimeSelect(slot)"
            >
              {{ slot.displayTime }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-footer" *ngIf="showFooterButtons">
      <div class="footer-buttons">
        <button type="button" class="btn btn-outline" (click)="cancelSelection()">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="applySelection()"
          [disabled]="!isSelectionComplete()"
          [class.disabled]="!isSelectionComplete()"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
